import React, {useEffect} from 'react';
import {useIdleTimer} from 'react-idle-timer';
import {useDispatch} from 'react-redux';
import {deleteUserCredential, saveUserCredential, updateUserActive} from '../redux/actions/LocalUserActions';
import config from '../config';
import {useTypedSelector} from '../redux/reducers/RootReducer';
import {getUserCredential, isUserCredentialActive} from '../redux/reducers/LocalUserReducer';
import UserCredentialUtil from '../Utility/UserCredentialUtil';
import store from '../redux/store';
import UserApi from '../api/UserApi';

export default function UserActivityWatcher() {
  const dispatch = useDispatch();
  const user = useTypedSelector((state) => getUserCredential(state));
  const isUserActive = useTypedSelector((state) => isUserCredentialActive(state));

  const handleOnIdle = (event: Event) => {
    console.log('user is idle', event);
    dispatch(updateUserActive(false));
  };

  const handleOnActive = (event: Event) => {
    console.log('user is Active', event);
    dispatch(updateUserActive(true));
  };

  useIdleTimer({
    timeout: 1000 * config.USER_IDLE_TIMEOUT,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    debounce: 500,
    crossTab: true,
  });

  useEffect(() => {
    let refreshTokenTimer: NodeJS.Timeout | undefined = undefined;
    let expiredTime = UserCredentialUtil.getUserExpiredTime(user);
    if (user && expiredTime) {
      const expiredInSecond = expiredTime.getTime() / 1000;
      const nowInSecond = new Date().getTime() / 1000;
      const deltaTimeInSeconds = expiredInSecond - nowInSecond;
      if (deltaTimeInSeconds < config.REFRESH_TOKEN_BEFORE_EXPIRED_IN_SECONDS && deltaTimeInSeconds > 0) {
        refreshTokenTimer = setTimeout(() => {
          if (isUserActive) {
            UserApi.refreshToken(user).then((result) => {
              if (result) {
                dispatch(saveUserCredential(result));
              }
            });
          } else {
            dispatch(deleteUserCredential());
          }
        }, (deltaTimeInSeconds - config.REFRESH_TOKEN_BEFORE_EXPIRED_IN_SECONDS) * 1000);
      }
    }

    return () => {
      if (refreshTokenTimer !== undefined) {
        clearTimeout(refreshTokenTimer);
      }
    };
  }, [isUserActive, user]);

  return <></>;
}
